import React, { useState, useEffect, useRef } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import { makeStyles } from "@mui/styles";

import api from "../../services/api";

const useStyles = makeStyles((theme) => ({
  qaList: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 4,
    maxHeight: 220,
    overflowY: "auto",
    marginTop: 8,
  },
  qaItem: {
    padding: "4px 8px",
    "&:hover": { backgroundColor: theme.palette.action.hover },
    cursor: "pointer",
  },
  msgField: {
    marginTop: 12,
  },
  hint: {
    fontSize: 12,
    color: "#8A9096",
    marginTop: 4,
  },
}));

const ResolveTicketModal = ({ open, onClose, onConfirm }) => {
  const classes = useStyles();
  const [message, setMessage] = useState("");
  const [searchParam, setSearchParam] = useState("");
  const [quickAnswers, setQuickAnswers] = useState([]);
  const timerRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    setMessage("");
    setSearchParam("");
    api.get("/quickAnswers/", { params: { searchParam: "" } })
      .then(({ data }) => setQuickAnswers(data.quickAnswers || []))
      .catch(() => {});
  }, [open]);

  const handleSearch = (e) => {
    const val = e.target.value;
    setSearchParam(val);
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      api.get("/quickAnswers/", { params: { searchParam: val } })
        .then(({ data }) => setQuickAnswers(data.quickAnswers || []))
        .catch(() => {});
    }, 300);
  };

  const handleSelectQa = (qa) => {
    setMessage(qa.message);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" disableRestoreFocus>
      <DialogTitle>Resolver atendimento</DialogTitle>
      <DialogContent>
        <Typography variant="body2" style={{ marginBottom: 8 }}>
          Selecione uma resposta rápida ou escreva uma mensagem de encerramento (opcional).
        </Typography>

        <TextField
          size="small"
          fullWidth
          variant="outlined"
          placeholder="Buscar resposta rápida..."
          value={searchParam}
          onChange={handleSearch}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon style={{ fontSize: 18, color: "#8A9096" }} />
              </InputAdornment>
            ),
          }}
        />

        {quickAnswers.length > 0 && (
          <List dense className={classes.qaList}>
            {quickAnswers.map((qa) => (
              <ListItem
                key={qa.id}
                button
                className={classes.qaItem}
                onClick={() => handleSelectQa(qa)}
              >
                <Chip
                  label={qa.shortcut}
                  size="small"
                  color="primary"
                  style={{ marginRight: 8, flexShrink: 0, fontSize: 11 }}
                />
                <ListItemText
                  primary={qa.message}
                  primaryTypographyProps={{
                    noWrap: true,
                    style: { fontSize: 13, overflow: "hidden", textOverflow: "ellipsis" },
                  }}
                />
              </ListItem>
            ))}
          </List>
        )}

        <TextField
          className={classes.msgField}
          label="Mensagem de encerramento"
          multiline
          rows={3}
          fullWidth
          variant="outlined"
          size="small"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Ex: Fico à disposição! Até logo."
        />
        <Typography className={classes.hint}>
          Deixe em branco para resolver sem mensagem.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="default">
          Cancelar
        </Button>
        <Button onClick={() => onConfirm(null)} color="default" variant="outlined">
          Resolver sem mensagem
        </Button>
        <Button
          onClick={() => onConfirm(message.trim() || null)}
          color="primary"
          variant="contained"
          disabled={false}
        >
          {message.trim() ? "Enviar e resolver" : "Resolver"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ResolveTicketModal;
